import * as types from 'api-paths-cas';
import { SMapWhen, SMapMatch } from 'api-paths-cas';
import { IOption } from 'shared-components';

import { APICall } from '../../types';

export type IProgrammableTag = types.IProgrammableTag;

export interface IProgrammableTagState {
  programmableTags: Array<IProgrammableTag>;
  appliedTagsCount: number | null;
  apiCallsInProgress: Array<APICall>;
  removedTagsCount: number | null;
}

export const tagWhenOptions: IOption[] = [
  {
    label: 'When the following conditions *are* met',
    value: SMapWhen.CONDITION,
  },
  {
    label: 'When the following conditions *are not* met',
    value: SMapWhen.EXCLUDE_CONDITION,
  },
];

export const tagMatchOptions: IOption[] = [
  { label: 'equals', value: SMapMatch.EQUALS },
  { label: 'not equals', value: SMapMatch.NOT_EQUALS },
  { label: 'contains', value: SMapMatch.CONTAINS },
  { label: 'not contains', value: SMapMatch.NOT_CONTAINS },
  { label: 'starts with', value: SMapMatch.STARTS_WITH },
  { label: 'not starts with', value: SMapMatch.NOT_STARTS_WITH },
  { label: 'exists', value: SMapMatch.EXISTS },
  { label: 'not exists', value: SMapMatch.NOT_EXISTS },
  { label: 'one of', value: SMapMatch.ONE_OF },
  { label: 'not one of', value: SMapMatch.NOT_ONE_OF },
  { label: 'greater than', value: SMapMatch.GREATER_THAN },
  { label: 'less than', value: SMapMatch.LESS_THAN },
];

export const dropdownMatchOptions: IOption[] = [
  { label: 'equals', value: SMapMatch.EQUALS },
  { label: 'not equals', value: SMapMatch.NOT_EQUALS },
];

export const DROPDOWN_SELECTOR_FIELDS = ['riskRegion'];

export enum ProgrammableTagTypes {
  GET_PROGRAMMABLE_TAGS = '@@programmable-tags/GET_PROGRAMMABLE_TAGS',
  GET_PROGRAMMABLE_TAGS_SUCCESS = '@@programmable-tags/GET_PROGRAMMABLE_TAGS_SUCCESS',
  GET_PROGRAMMABLE_TAGS_FAILURE = '@@programmable-tags/GET_PROGRAMMABLE_TAGS_FAILURE',
}
